import { type Immutable } from 'immer';
import { z, AnyZodObject } from 'zod';

import { ModelForm } from '@tdp/common/form';
import { useTemporaryState } from '@tdp/common/shared/useTemporaryState';

import { createValidationHook } from './createValidationHook';

export function createModelFormHook<TSchema extends AnyZodObject>(
  schema: TSchema
) {
  // TODO(nibeauli): this augmentation _might_ need to be generalized to support more than just
  // validation for the specified object.
  // This would mean that the augmentations would need to define 'zoom' as well.
  const useValidation = createValidationHook(schema);

  return function useModelForm(
    defaultValue: z.infer<TSchema>
  ): ModelForm<TSchema> {
    const { state, clearState, updateState } = useTemporaryState(defaultValue);
    const validationErrors = useValidation(state);
    return {
      base: defaultValue as Immutable<typeof defaultValue>,
      current: state as Immutable<typeof state>,
      clear: clearState,
      update: updateState,
      validationErrors,
    };
  };
}
